import { BaseModal, ModalOptions, ModalResultType } from "../../../../../core/modal/index";
import { Template } from "../../../../../core/template/index";

export default class ReceiveConfirmModal extends BaseModal
{
    public template = Template.lazy('/app/views/package_tracking/modals/receive_confirm/index.html');

    constructor(items: any[])
    {
        super();
        this.data.items = items;
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Confirm receive')
        }
    }

    public onCancelClicked(e: Event)
    {
        this.close(ModalResultType.CANCEL);
    }

    public onSubmit(event: Event)
    {
        this.close(ModalResultType.OK);
    }
}